export const CURRENT_USER_OPTIONS = {
  FULLNAME: "CurrentUser.FullName",
  FIRST_NAME: "CurrentUser.FirstName",
  LAST_NAME: "CurrentUser.LastName",
  TITLE: "CurrentUser.Title",
  SUFFIX: "CurrentUser.Suffix",
  SIGNATURE: "CurrentUser.Signature",
};

export const CURRENT_USER_MENU_OPTIONS = {
  title: "Current User",
  menu: [
    {
      title: "Current User - Full Name",
      value: CURRENT_USER_OPTIONS.FULLNAME,
    },
    {
      title: "Current User - First Name",
      value: CURRENT_USER_OPTIONS.FIRST_NAME,
    },
    {
      title: "Current User - Last Name",
      value: CURRENT_USER_OPTIONS.LAST_NAME,
    },
    {
      title: "Current User - Title",
      value: CURRENT_USER_OPTIONS.TITLE,
    },
    {
      title: "Current User - Suffix",
      value: CURRENT_USER_OPTIONS.SUFFIX,
    },
    {
      title: "Current User - Signature",
      value: CURRENT_USER_OPTIONS.SIGNATURE,
    },
  ],
};
